<template>
  <SmartMorphIcon
    :state.sync="localState"
    @click="s => $emit('click', s)"
    @toggle="s => $emit('toggle', s)"
    @stateChange="s => $emit('stateChange', s)"
    frameIdPrefix="BurgerMenuIconStep-" :rootClass="rootClass">
      <g id="BurgerMenuIconStep-1">
        <g id="Group 8">
          <rect id="Rectangle 337" x="20" y="55" width="260" height="20" fill="#07689f" transform="rotate(0)"/>
          <rect id="Rectangle 338" x="20" y="135" width="260" height="20" fill="#07689f" transform="rotate(0)" />
          <rect id="Rectangle 339" x="20" y="215" width="260" height="20" fill="#07689f" transform="rotate(0)" />
        </g>
      </g>
      <g id="BurgerMenuIconStep-2">
        <g id="Group 8">
          <rect id="Rectangle 337" x="20" y="135" width="260" height="20" fill="#07689f" transform="rotate(0)" />
          <rect id="Rectangle 338" x="20" y="135" width="260" height="20" fill="#07689f" transform="rotate(0)" />
          <rect id="Rectangle 339" x="20" y="135" width="260" height="20" fill="#07689f" transform="rotate(0)" />
        </g>
      </g>
      <g id="BurgerMenuIconStep-3" class="opacity-0">
        <g id="Group 8">
          <rect
            id="Rectangle 337"
            x="68.6827"
            y="47.4695"
            width="260"
            height="20"
            transform="rotate(45 68.6827 47.4695)"
            fill="#07689f"
          />
          <rect
            id="Rectangle 339"
            x="47.4695"
            y="231.318"
            width="260"
            height="20"
            transform="rotate(-45 47.4695 231.318)"
            fill="#07689f"
          />
        </g>
      </g>
      <g id="BurgerMenuIconStep-4" class="opacity-0">
        <g id="Group 8">
          <rect
            id="Rectangle 337"
            x="68.6827"
            y="47.4695"
            width="260"
            height="20"
            transform="rotate(45 68.6827 47.4695)"
            fill="#07689f"
          />
          <rect
            id="Rectangle 339"
            x="47.4695"
            y="231.318"
            width="260"
            height="20"
            transform="rotate(-45 47.4695 231.318)"
            fill="#07689f"
          />
        </g>
      </g>
  </SmartMorphIcon>
</template>
<script>
import SmartMorphIcon from '@/components/InteractiveIcons/SmartMorphIcon.vue';

export default {
  name: 'DropdownIcon',
  components: { SmartMorphIcon },
  props: {
    rootClass: {
      type: String,
      default: '',
    },
    state: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      localState: this.state,
    };
  },
  watch: {
    state(newVal) {
      if (this.localState !== newVal) {
        this.localState = newVal;
      }
    },
    localState(newVal) {
      this.$emit('update:state', newVal);
    },
  },
};
</script>
